import * as  Yup from "yup"


export const registerValidations = Yup.object({
    email: Yup.string().email("invalid email address").required('Please enter your email address'),
    firstname: Yup.string().required('Please enter your first name'),
    lastname: Yup.string().required('Please enter your last name'),
    password: Yup.string()
        .required('please enter your password')
        .matches(/^(?=.{8,})/, "Must contain at least 8 characters")
        .matches(/[A-Z]/, "Must contain one uppercase letter")
        .matches(/[0-9]|[^A-Za-z0-9]/, "Must contain one number or symbol"),
    confirmPassword: Yup.string().required('please retype your password.').oneOf([Yup.ref('password')], 'your passwords does not match.'),
    register_checkbox: Yup.boolean().oneOf([true], 'Must Accept Terms and Conditions')
})
export const loginValidations = Yup.object({
    email: Yup.string().email("invalid email address").required('Please enter your email address'),
    password: Yup.string().required('please enter your password')
    // curPassword: Yup.string().required('please enter your current password')
})

// For NewsFeed Modal Form
export const createProfileValidations = Yup.object({
    firstName: Yup.string().required('Please enter your first name'),
    lastName: Yup.string().required('please enter your last name')
})